export interface MedicationDosageUnitConfig {
    maxDecimals: number;
    step: number;
}

const UNIT_CONFIG_BY_NAME: Record<string, MedicationDosageUnitConfig> = {
    ml: { maxDecimals: 2, step: 0.1 },
    g: { maxDecimals: 2, step: 0.1 },
    drop: { maxDecimals: 0, step: 1 },
    tbsp: { maxDecimals: 2, step: 0.5 },
    tsp: { maxDecimals: 2, step: 0.5 },
    pill: { maxDecimals: 2, step: 0.5 },
    mg: { maxDecimals: 0, step: 1 }
};

export function getMedicationDosageUnitConfig(unitName: string): MedicationDosageUnitConfig | undefined {
    const key = unitName.trim().toLowerCase();
    return UNIT_CONFIG_BY_NAME[key];
}

export function getMaxDecimalsForUnit(unitName: string): number | undefined {
    return getMedicationDosageUnitConfig(unitName)?.maxDecimals;
}

export function getStepForUnit(unitName: string): number {
    return getMedicationDosageUnitConfig(unitName)?.step ?? 1;
}

export function countDecimals(value: number): number {
    if (Number.isInteger(value)) return 0;
    const s = String(value);
    const i = s.indexOf('.');
    return i === -1 ? 0 : s.length - i - 1;
}

export function isValidDecimalPlaces(value: number, maxDecimals: number): boolean {
    return countDecimals(value) <= maxDecimals;
}
